import { message } from "antd";
import { MessageContext } from "@/contexts";

export const MessageProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [messageApi, messageContextHolder] = message.useMessage({ top: 40 });

  return (
    <MessageContext.Provider value={{ messageApi, messageContextHolder }}>
      {children}
    </MessageContext.Provider>
  );
};
